const API_URL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'http://127.0.0.1:8000/api/editor' : "/api/editor";
const HEADERS = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? {'email':'leonardo.curini@thefacultyapp.com'} : {};

class server {
    async standard_api_call(api_url, data_to_send) {

        var json_to_send = JSON.stringify(data_to_send);

        var api_url_end = API_URL + api_url;

        try {
            let _t = await fetch(api_url_end, {
                method: 'POST',
                cache: 'no-cache',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'charset': 'utf-8',
                    ...HEADERS
                },
                body: json_to_send
            });
            return _t.json();
        } catch (e) {
            return { success: false, error: e.message };
        }
    }

    async get_api_call(api_url) {

        var api_url_end = API_URL + api_url;

        try {
            let _t = await fetch(api_url_end, {
                method: 'GET',
                headers: HEADERS
            });
            return _t.json();
        } catch (e) {
            return { success: false, error: e.message };
        }
    }
    async get_permissions() {
        const response = await this.standard_api_call(`/get_user_permissions`);
        if (response.success === false || response.detail) return { success: false, error: response.detail ? response.detail : response.error };
        return { success: true, data: response };
    }
    async get_texts(to_review=true, skip=0, limit=100) {
        const response = await this.standard_api_call(`/list_texts`,{to_review:to_review, skip:skip, limit:limit});
        if (response.success === false || response.detail) return { success: false, error: response.detail ? response.detail : response.error };
        return { success: true, data: response };
    }
    async search_text(pattern="", skip=0, limit=100) {
        const response = await this.standard_api_call(`/search_text`,{pattern:pattern, skip:skip, limit:limit});
        if (response.success === false || response.detail) return { success: false, error: response.detail ? response.detail : response.error };
        return { success: true, data: response };
    }
    async get_text(languages, keys) {
        const response = await this.standard_api_call(`/get_texts_by_keys`,{languages:languages, keys:keys});
        if (response.success === false || response.detail) return { success: false, error: response.detail ? response.detail : response.error };
        return { success: true, data: response };
    }
    async translate_text(request_data) {
        const response = await this.standard_api_call("/translate_text", request_data);
        if (response.success === false || response.detail) return { success: false, error: response.detail ? response.detail : response.error };
        return { success: true, data: response };
    }
    async upsert_text(request_data) {
        const response = await this.standard_api_call("/upsert_text", request_data);
        if (response.success === false || response.detail) return { success: false, error: response.detail ? response.detail : response.error };
        return { success: true, data: response };
    }
    async approve_text(text_key) {
        const response = await this.standard_api_call("/update_revision_status", {key:text_key, to_review:false});
        if (response.success === false || response.detail) return { success: false, error: response.detail ? response.detail : response.error };
        return { success: true, data: response };
    }
    
}

export default new server();